<template>
  <div v-if="tagIds.length || hasDefaultSlot" class="sf-level remark-tags-list">
    <span v-for="tag in remarkTags" :key="tag.id" class="sf-label">
      {{ tag.name }}
    </span>
    <span class="slot-wrapper">
      <slot />
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    tagIds: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['remarkTagById']),
    hasDefaultSlot() {
      const defaultSlot = this.$slots?.default
      return typeof defaultSlot === 'function'
        ? !!this.$slots?.default()
        : false
    },
    remarkTags() {
      return this.tagIds
        .map((id) => {
          const tag = this.remarkTagById(id)
          if (tag) {
            return { id, name: tag.name }
          }
        })
        .filter((t) => t)
    },
  },
}
</script>

<style scoped>
.remark-tags-list .slot-wrapper {
  margin-bottom: 5px;
}
</style>
